const Loader = () : JSX.Element => {
    return (
        <div className="spinnerOverlay"><div className="spinner"><span className="sr-only">Loading...</span></div></div>
    );
};

export default Loader
